import { RoutesState } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const routesSelector = (state: RootState): RoutesState => state.routes;

export const selectInitialRoute = createSelector([routesSelector], routes => routes.initialRoute);
